export class CurrentFaseModel {
  tahunAnggaran: any;
  idFase: number;
  fase: string;
  faseSelanjutnya: string;
  pergeseranCount: number;
  isPerubahanOpen: boolean;
  isPerubahanUsed: boolean;
  isLock: any;
  pelaksanaanCount: number;
  isLockSkpd: any;
}

export class FaseModel {
  id: number;
  namaFase: string;
}
